module.exports = __webpack_public_path__ + "img/productionBaseR_2.32b66e89.png";